var _path, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.909 3.43323e-05C16.053 3.43323e-05 18.165 2.15303 18.165 5.35703V14.553C18.165 17.785 16.118 19.887 12.95 19.907L5.257 19.91C2.113 19.91 0 17.757 0 14.553V5.35703C0 2.12403 2.047 0.0230343 5.215 0.00403433L12.908 3.43323e-05H12.909ZM12.909 1.50003L5.22 1.50403C2.892 1.51803 1.5 2.95803 1.5 5.35703V14.553C1.5 16.968 2.905 18.41 5.256 18.41L12.945 18.407C15.273 18.393 16.665 16.951 16.665 14.553V5.35703C16.665 2.94203 15.261 1.50003 12.909 1.50003Z",
    fill: "#222222"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.91016,
    width: 11,
    height: 4,
    rx: 1.5,
    stroke: "#222222",
    strokeWidth: 1.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 10.4102,
    width: 4.5,
    height: 6,
    rx: 1.5,
    stroke: "#222222",
    strokeWidth: 1.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10.4102,
    width: 4.5,
    height: 6,
    rx: 1.5,
    stroke: "#222222",
    strokeWidth: 1.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocAlt);
export default __webpack_public_path__ + "static/media/doc-alt.969e96d07ce74c5ad876e9ccdb24c6e8.svg";
export { ForwardRef as ReactComponent };